import styled from 'styled-components';

const TBody = styled.tbody``;

export { TBody };
